import React from 'react';
import { useTranslation } from 'react-i18next';
import { Status } from '@guryou/core';
import { dateIsAfter, dateIsBefore } from '@guryou/utils';
import ServiceCard from '../../components/ServiceCard';

const ServiceCards = ({ view, data, status, isNotVideo = false }) => {
  const { t } = useTranslation();

  const cards = isNotVideo
    ? status === Status.upcoming
      ? data.filter(x => x.type && dateIsAfter(x.startTime))
      : data.filter(x => x.type && dateIsBefore(x.startTime))
    : data;

  const viewName = view.charAt(0).toUpperCase() + view.slice(1);

  return (
    <>
      <div className="space-y-6">
        <div className="flex items-center gap-2">
          <h3 className="text-xl font-bold text-gray-900">{viewName}</h3>
          <span className="text-sm text-gray-500">({status})</span>
        </div>

        {cards.length ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {cards.map((x, i) => (
              <ServiceCard key={i + Date.now()} item={x} isNotVideo={isNotVideo} />
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <p className="text-gray-500">
              {t('RESERVATIONS.noReservations')} - {t(`PROFILE.${status}`)} {t(`GENERAL.${view}s`)}
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default ServiceCards;
